import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownViolationContext } from "./form-dropdown-violation.context";

export interface FormDropdownViolationProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownViolation<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownViolationProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newViolation,
    mappedViolation,
    isCreating,
    setSidebar,
    setFilter,
    setNewViolation,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownViolationContext();
  
  return (
    <div className="violation">
      {newViolation && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new violation</h2>
          <p>
            You are creating a new violation. Please, fill the fields to create a
            new violation and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="Violation Name"
              value={newViolation.name}
              onChange={(e: any) =>
                setNewViolation({ ...newViolation, name: e.target.value })
              }
            />
            <InputText
              placeholder="Violation Description"
              value={newViolation.description}
              onChange={(e: any) =>
                setNewViolation({ ...newViolation, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="Violation"
        options={ mappedViolation }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your violation"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownViolation;